import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from "@firebase/auth";
import { getStorage } from "@firebase/storage";
import { getFunctions } from "firebase/functions";

// PRODUCTION ENVIRONMENT
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_KEY_PROD,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN_PROD,
  projectId: process.env.REACT_APP_FB_PROJECT_ID_PROD,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET_PROD,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_PROD,
  appId: process.env.REACT_APP_FB_APP_ID_PROD
};

// SANDBOX ENVIRONMENT
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FB_KEY_SB,
//   authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN_SB,
//   projectId: process.env.REACT_APP_FB_PROJECT_ID_SB,
//   storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET_SB,
//   messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_SB,
//   appId: process.env.REACT_APP_FB_APP_ID_SB,
//   measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID_SB
// };

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// https://github.com/firebase/firebase-js-sdk/issues/5548
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence]
});

export const storage = getStorage();
export const db = getFirestore();
export const functions = getFunctions(app);
